import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-auto-save-dynamic-timer',
  templateUrl: './auto-save-dynamic-timer.component.html',
  styleUrls: ['./auto-save-dynamic-timer.component.scss']
})
export class AutoSaveDynamicTimerComponent {
  @Input() showTimer: boolean = false;
  @Input() displaySecond: number = 0;
  @Input() caption: string = 'AUTOSAVING';
  constructor() { }
}
